import script from "./DataDictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDictionary.vue?vue&type=script&setup=true&lang=js"

import "./DataDictionary.vue?vue&type=style&index=0&id=2c634356&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c634356"]])

export default __exports__